module.exports = __webpack_public_path__ + "img/flogo_RGB_HEX-72.ebb754ba.svg";